module.exports = __webpack_public_path__ + "img/123-british-columbia.532014e3.svg";